import React from 'react';
import PropTypes from 'prop-types';
import {getPlatform} from "@/hooks";

const SaveButton = ({
    handleSave,
    baseClass,
    saveButtonDisabled,
    text,
}) => {
    const disabledButtonClassName = saveButtonDisabled ? 'm2g-button--disabled' : '';

    if (getPlatform() === 'web') {
        return (
            <button
                className={baseClass(`-save m2g-button m2g-button--primary ${disabledButtonClassName}`)}
                disabled={saveButtonDisabled}
                onClick={(e) => handleSave(e)}
                type='submit'
            >
                {text}
            </button>
        );
    }

    return (
        <div
            className={baseClass('-save-button-container')}
        >
            <button
                className={baseClass(`-save-button m2g-button m2g-button--primary ${disabledButtonClassName}`)}
                disabled={saveButtonDisabled}
                onClick={(e) => handleSave(e)}
                type='submit'
            >
                {text}
            </button>
        </div>
    );
};

SaveButton.defaultProps = {
    saveButtonDisabled: false,
}

SaveButton.propTypes = {
    baseClass: PropTypes.func.isRequired,
    saveButtonDisabled: PropTypes.bool,
    handleSave: PropTypes.func.isRequired,
    text: PropTypes.string.isRequired,
};

export default SaveButton;
